// AG Grid Internationalization Configuration - English
export default {
  // Basic text
  noRowsToShow: 'No Rows To Show',
  loadingOoo: 'Loading...',

  // Pagination
  page: 'Page',
  more: 'More',
  to: 'to',
  of: 'of',
  next: 'Next',
  last: 'Last',
  first: 'First',
  previous: 'Previous',

  // Row selection
  selectAll: 'Select All',
  selectAllFiltered: 'Select All Filtered',
  deselectAll: 'Deselect All',

  // Column operations
  columns: 'Columns',
  filters: 'Filters',

  // Context menu
  copy: 'Copy',
  copyWithHeaders: 'Copy with Headers',
  paste: 'Paste',
  export: 'Export',
  csvExport: 'CSV Export',
  excelExport: 'Excel Export',
  exportSelectedRows: 'Export Selected Rows',
  exportCurrentPage: 'Export Current Page',
  exportSelectedRowsExcel: 'Export Selected Rows (Excel)',
  exportSelectedRowsCsv: 'Export Selected Rows (CSV)',
  exportAllRowsExcel: 'Export All Rows (Excel)',
  exportAllRowsCsv: 'Export All Rows (CSV)',
  exportCurrentPageExcel: 'Export Current Page (Excel)',
  exportCurrentPageCsv: 'Export Current Page (CSV)',

  // Column menu
  pinColumn: 'Pin Column',
  pinLeft: 'Pin Left',
  pinRight: 'Pin Right',
  noPin: 'No Pin',
  valueAggregation: 'Value Aggregation',
  autosizeThiscolumn: 'Autosize This Column',
  autosizeAllColumns: 'Autosize All Columns',
  groupBy: 'Group by',
  ungroupBy: 'Un-Group by',
  resetColumns: 'Reset Columns',
  expandAll: 'Expand All',
  contractAll: 'Collapse All',

  // Filters
  filterOoo: 'Filter...',
  equals: 'Equals',
  notEqual: 'Not equal',
  lessThan: 'Less than',
  greaterThan: 'Greater than',
  lessThanOrEqual: 'Less than or equals',
  greaterThanOrEqual: 'Greater than or equals',
  inRange: 'In range',
  contains: 'Contains',
  notContains: 'Not contains',
  startsWith: 'Starts with',
  endsWith: 'Ends with',
  blank: 'Blank',
  notBlank: 'Not blank',

  // Filter buttons
  applyFilter: 'Apply Filter',
  clearFilter: 'Clear Filter',
  resetFilter: 'Reset Filter',
  cancelFilter: 'Cancel',

  // Text filters
  textFilter: 'Text Filter',
  numberFilter: 'Number Filter',
  dateFilter: 'Date Filter',
  setFilter: 'Set Filter',

  // Filter conditions
  andCondition: 'AND',
  orCondition: 'OR',

  // Sorting
  sortAscending: 'Sort Ascending',
  sortDescending: 'Sort Descending',
  sortUnSort: 'Clear Sort',

  // Tool panel
  toolPanelColumns: 'Columns',
  toolPanelFilters: 'Filters',

  // Columns tool panel
  pivotMode: 'Pivot Mode',
  groups: 'Row Groups',
  rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
  values: 'Values',
  valueColumnsEmptyMessage: 'Drag here to aggregate',
  pivots: 'Column Labels',
  pivotColumnsEmptyMessage: 'Drag here to set column labels',

  // Others
  loadingError: 'Loading Error',
  refreshHeaderFailed: 'Failed to refresh header locale text',
  noDataToShow: 'No Data To Show',
  enabled: 'Enabled',

  // Input validation
  invalidDate: 'Invalid Date',
  invalidNumber: 'Invalid Number',

  // Grouping
  group: 'Group',

  // Master-detail expand column
  expandRows: 'Expand',
  collapseRows: 'Collapse',

  // Pivot
  pivot: 'Pivot',

  // Enterprise features
  pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
  pivotChart: 'Pivot Chart',
  chartRange: 'Chart Range',

  // Status bar
  sum: 'Sum',
  min: 'Min',
  max: 'Max',
  none: 'None',
  count: 'Count',
  avg: 'Average',

  // Search
  searchOoo: 'Search...',

  // Row drag
  rowDragEntireRow: 'Drag Entire Row',
  rowDragRow: 'Drag Row',

  // Other enterprise features
  pivotColumnGroupTotals: 'Pivot Column Group Totals',
  pivotRowTotals: 'Pivot Row Totals',
  pivotColumnGroupTotal: 'Total',

  // Sidebar
  sideBarColumns: 'Columns',
  sideBarFilters: 'Filters',

  // Column visibility
  visible: 'Visible',
  hidden: 'Hidden'
}
